// extracted by mini-css-extract-plugin
module.exports = {"row":"Table_row__329lz","selectedRow":"Table_selectedRow__2RDgG","text":"Table_text__EHapT"};